import PropTypes from 'prop-types';

export const ActionType = {
  Sms: 'Sms',
  Email: 'Email',
};

export const ActionValueType = PropTypes.arrayOf(PropTypes.oneOf(Object.values(ActionType)));
